//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

  export default{
    name: 'finshed',
    data(){
      return {
        list: [
          {
            img_left: 'http://yiyang.oss-cn-beijing.aliyuncs.com/html/AnswerGold/%E7%9B%B4%E6%92%AD@2x.png',
            p1: '直播',
            p2: '每天4场，准时开讲',
            type:'live'
          }, {
            img_left: 'http://yiyang.oss-cn-beijing.aliyuncs.com/html/AnswerGold/%E8%AF%BE%E7%A8%8B@2x.png',
            p1: '课程',
            p2: '覆盖13大学科，精彩应有尽有',
            type:'course'
          }, {
            img_left: 'http://yiyang.oss-cn-beijing.aliyuncs.com/html/AnswerGold/%E5%A4%B4%E6%9D%A1@2x.png',
            p1: '头条',
            p2: '新鲜资讯、病例，一网打尽',
            type:'headline'
          }
        ]
      }
    },
    methods: {
        jump(item){
            if(item.type == 'live'){
              location.href = '/html/newWechat.html#/liveTrailer'
            }else if(item.type == 'course'){
              location.href = '/html/newWechat.html#/courseList'
            }else{
              location.href = '/html/newWechat.html#/headlineList'
            }
        }
    },
    computed: {

    },
    components: {},
    mounted(){

    },
    beforeRouteLeave (to,from,next){
      if(to.name == 'play'){
          next({name:'home'})
      }else{
        next()
      }
    }
  }



// WEBPACK FOOTER //
// ./src/page/Finshed/index.vue